import { render, staticRenderFns } from "./PhotosPublic.vue?vue&type=template&id=2d3dc3bc"
import script from "./PhotosPublic.vue?vue&type=script&lang=js"
export * from "./PhotosPublic.vue?vue&type=script&lang=js"
import style0 from "./PhotosPublic.vue?vue&type=style&index=0&id=2d3dc3bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports